<template>
  <v-card flat>
    <v-tabs v-model="tab" centered>
      <v-tabs-slider></v-tabs-slider>

      <v-tab href="#projets">
        Projets
      </v-tab>

      <v-tab href="#regions">
        régions
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item value="projets">
        <v-card flat>
          <v-card-text>
            <v-data-table
              :headers="headersProjet"
              :items="Projets"
             
            >
            <template v-slot:item.nombre="{ item }">
               nombre
              </template>
              <template v-slot:item.actions="{ item }">
               load
              </template>
        
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item value="regions">
        <v-card flat>
          <v-card-text>
            <v-data-table
              hide-default-footer
              :items-per-page="100"
              :headers="headers"
              :items="Regions"
            >
              <template v-slot:item.nombre="{ item }">
                {{ item.nbreGroupe }}
              </template>
              <template v-slot:item.date="{ item }">
               date
              </template>
              <template v-slot:item.actions="{ item }">
                action
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      tab: "projets",
      headers: [
        {
          text: "Region",
          align: "start",

          value: "ll_region",
        },
        { text: "Nombre Groupe", value: "nombre", sortable: false },
        { text: "Actions", value: "actions", sortable: false },
      ],
      headersProjet: [
        {
          text: "Projet",
          align: "start",
          value: "ll_programme",
        },
        { text: "Nombre", value: "nombre", sortable: false },
        { text: "Actions", value: "actions", sortable: false },
      ],
    };
  },
  computed: {
    ...mapState({
      Regions: (state) => state.Regions.Regions,
      Projets: (state) => state.Projets.projets,
    }),
  },
};
</script>

<style scoped></style>
